

















import { Component, Vue } from 'vue-property-decorator'
import BookmarkInPage from './BookmarkInPage.vue'
import { membershipState } from '../../store/modules/MembershipState'

@Component({
  components: {
    BookmarkInPage
  }
})
export default class BookmarkMobile extends Vue {
  // ------------------------------------------------------------------------------------------------
  // data
  private isMobileScreen = false

  // ------------------------------------------------------------------------------------------------
  // get
  private get bookmarkInPage(): BookmarkInPage {
    return this.$refs.bookmarkInPage as BookmarkInPage
  }

  private get isBookmarked() {
    return membershipState.isBookmarked
  }

  // ------------------------------------------------------------------------------------------------
  // hooks
  private created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  }

  private destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }

  // ------------------------------------------------------------------------------------------------
  // computed
  get hasPageId(): boolean {
    if (drupalSettings.vueComponent.contentTop) {
      return true
    }
    return false
  }

  // ------------------------------------------------------------------------------------------------
  // methods
  private handleResize() {
    this.isMobileScreen = window.innerWidth <= 750
  }

  private addBookmark() {
    this.bookmarkInPage.addCurrentPageBookmark()
  }

  private removeBookmark() {
    this.bookmarkInPage.removeCurrentPageBookmark()
  }
}
